module.exports = __webpack_public_path__ + "assets/CircleTangentCPwCenterLDetailed.6e253b95f7ba23f36d5fa731b2689bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleTangentCPwCenterLDetailed.png
// module id = 493
// module chunks = 0